import React from "react";
import { Tooltip } from "antd";
import { RESEARCH_TYPE } from "../utils/consts";
import englishJson from "../utils/language/leStudy/english.json";
import spanishJson from "../utils/language/leStudy/spanish.json";
import noLanguageJson from "../utils/language/leStudy/noLanguage.json";

const getPasswordNotesContent = (language) => {
  if (RESEARCH_TYPE === "LE Study") {
    const lang =
      language ||
      (typeof window !== "undefined" &&
        (window.localStorage.getItem("ap_language") || "")) ||
      "English";

    const formData =
      lang === "English"
        ? englishJson
        : lang === "Spanish"
          ? spanishJson
          : noLanguageJson;

    const passwordReq =
      formData?.page?.createAccount?.form?.passwordRequirements;

    if (
      passwordReq &&
      Array.isArray(passwordReq.requirements) &&
      passwordReq.requirements.length
    ) {
      return {
        title: passwordReq.title || "Notes",
        notes: passwordReq.requirements,
      };
    }
  }

  return {
    title: "Password Requirements",
    notes: [
      "Password must be 8 to 15 characters long",
      "Include at least one uppercase (A–Z) and one lowercase (a–z) letter",
      "Include at least one number (0–9)",
      "Include at least one special character (!@#$%^&*)",
    ],
  };
};

const PasswordNotesTooltip = ({ language }) => {
  const { title, notes } = getPasswordNotesContent(language);

  return (
    <Tooltip
      title={
        <div style={{ padding: "6px 4px", minWidth: 320 }}>
          <div
            style={{
              fontWeight: 700,
              marginBottom: 10,
              fontSize: 13,
              borderBottom: "1px solid rgba(255,255,255,0.2)",
              paddingBottom: 6,
              letterSpacing: 0.3,
            }}
          >
            {title}
          </div>
          <ul style={{ margin: 0, paddingLeft: 0, listStyle: "none" }}>
            {notes.map((note, index) => (
              <li key={index} style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 8,
                marginBottom: index < notes.length - 1 ? 7 : 0,
                fontSize: 12,
                lineHeight: "1.5",
              }}
              >
                <span
                  style={{
                    color: "#4caf50",
                    fontWeight: 700,
                    fontSize: 14,
                    lineHeight: "1.3",
                    flexShrink: 0,
                  }}
                >
                  ✓
                </span>
                <span>{note}</span>
              </li>
            ))}
          </ul>
        </div>
      }
      placement="top"
      overlayInnerStyle={{ minWidth: 360, maxWidth: 420 }}
    >
      <span
        style={{
          marginLeft: 8,
          cursor: "pointer",
          display: "inline-flex",
          verticalAlign: "middle",
        }}
      >
        <box-icon name="info-circle" type="solid" color="#b66b4b" size="18px" />
      </span>
    </Tooltip>
  );
};

export default PasswordNotesTooltip;
